import { Component } from "@angular/core";

import { NavParams, MenuController, NavController } from "ionic-angular";

import { OrderplacedPage } from "../orderplaced/orderplaced";
import { OrdersdispatchedPage } from "../ordersdispatched/ordersdispatched";
import { OrdersreceivedPage } from "../ordersreceived/ordersreceived";
import { TabDelivered } from "../orderdeliveredtabs/tabs-delivered";

import { HelperServiceProvider } from "../../../common/services/helper.service";

@Component({
  selector: "tabs-order",
  templateUrl: "tabs-order.html"
})
export class TabOrder {
  // set the root pages for each tab
  placed: any = OrderplacedPage;
  dispatched: any = OrdersdispatchedPage;
  received: any = OrdersreceivedPage;
  delivered: any = TabDelivered;

  mySelectedIndex: number;

  constructor(
    navParams: NavParams,
    public menu: MenuController,
    public helperService: HelperServiceProvider,
    public navCtrl: NavController
  ) {
    console.log("ONE", navParams.data);

    if (navParams.data.tabIndex != null) {
    }
  }

  ionViewDidLoad() {
    this.menu.enable(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/tabs/tab-order.ts